import { Link } from 'react-router-dom'
import { Mail } from 'lucide-react'

export function VerifyEmailPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 px-4">
      <div className="w-full max-w-sm text-center">
        <div className="flex items-center gap-2.5 mb-8 justify-center">
          <div className="h-9 w-9 rounded-xl bg-brand-500 flex items-center justify-center">
            <span className="text-white font-bold text-base">R</span>
          </div>
          <span className="font-semibold text-stone-900 text-xl tracking-tight">RezzOps</span>
        </div>

        <div className="card p-8">
          <div className="mx-auto mb-4 h-12 w-12 rounded-xl bg-brand-50 flex items-center justify-center">
            <Mail className="h-6 w-6 text-brand-600" />
          </div>
          <h1 className="text-lg font-semibold text-stone-900 mb-2">Check your email</h1>
          <p className="text-sm text-stone-500 mb-6">
            We sent a confirmation link to your email address. Click it to activate your account and sign in.
          </p>
          <Link
            to="/login"
            className="text-sm text-brand-600 hover:underline font-medium"
          >
            Back to sign in
          </Link>
        </div>
      </div>
    </div>
  )
}
